module.exports = __webpack_public_path__ + "static/img/genre_01.8523eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/genre_01.png
// module id = c5Tb
// module chunks = 0